import styled from "@emotion/styled";
import { useEffect, useRef, useState } from "react";
import UI from "@mile-meeting/mile-ui";
import { deleteBuilding, deleteFloor, updateBuildingName, updateFloorName } from "apis/resources/building";
import { useToast } from "hook/useToast";
import DeleteWarningModal from "../../../../pages/meeting/MeetingRoomManage/MeetingRoomManagement/delete-warning-modal";

type EditDropdownItemProps = {
  data: { name: string; id: string; provider?: "MILE" | "GOOGLE" };
  setData: (value?: { name: string; id: string; provider?: "MILE" | "GOOGLE" }) => void;
  position: { top: number; left: number };
  onUpdate?: (updateId: string) => void;
};

const EditDropdownItem = (props: EditDropdownItemProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [editName, setEditName] = useState<string>(props.data.name);
  const [openWarningModal, setOpenWarningModal] = useState<boolean>(false);
  const { showToast } = useToast();

  //TODO: 로직 수정 필요. Props.data.provider로 건물인지 층인지 구분하는 로직은 도메인과 맞지 않음
  const handleEditName = async () => {
    if (props.data.provider) {
      const res = await updateBuildingName(props.data.id, editName, props.data.provider ?? "MILE");
      if (res.success) {
        showToast("건물 이름이 수정되었습니다.", "success");
        props.setData();
        props.onUpdate?.(props.data.id);
      } else {
        if (res.message) showToast(res.message, "error");
      }
    } else {
      const res = await updateFloorName(props.data.id, editName);
      if (res.success) {
        showToast("층 이름이 수정되었습니다.", "success");
        props.setData();
        props.onUpdate?.(props.data.id);
      } else {
        if (res.message) showToast(res.message, "error");
      }
    }
  };

  //TODO: 로직 수정 필요. Props.data.provider로 건물인지 층인지 구분하는 로직은 도메인과 맞지 않음
  const handleDelete = async () => {
    if (props.data.provider) {
      const res = await deleteBuilding(props.data.id, props.data.name, props.data.provider ?? "MILE");
      if (res.success) {
        showToast("건물이 삭제되었습니다.", "success");
        props.setData();
        props.onUpdate?.(props.data.id);
      } else {
        if (res.message) showToast(res.message, "error");
      }
    } else {
      const res = await deleteFloor(props.data.id, props.data.name);
      if (res.success) {
        showToast("층이 삭제되었습니다.", "success");
        props.setData();
        props.onUpdate?.(props.data.id);
      } else {
        if (res.message) showToast(res.message, "error");
      }
    }
  };

  useEffect(() => {
    const handler = (event: any) => {
      if (props.data && ref.current && !ref.current.contains(event.target)) {
        props.setData();
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [props.data]);

  if (!props.data.id) return null;

  return (
    <>
      <Container ref={ref} style={{ display: props.data.id ? "flex" : "none", top: props.position.top + 8 }}>
        <NameContainer>
          <UI.Input value={editName} onChange={setEditName} width={200} size="small" maxLength={50} />
          <UI.Button
            size="small"
            onClick={handleEditName}
            title="수정"
            primary={false}
            style={{ height: "38px", whiteSpace: "nowrap" }}
          />
        </NameContainer>
        <BtnContainer>
          <UI.ButtonGroups.Text
            onClick={() => setOpenWarningModal(true)}
            showPrefixIcon
            type="negative"
            size="small"
            title="삭제하기"
            prefixIcon="trashCan"
          />
        </BtnContainer>
      </Container>
      <DeleteWarningModal
        title={`"${props.data.name.length > 28 ? props.data.name.slice(0, 28) + "..." : props.data.name}"을 삭제하시겠습니까?`}
        modalIsOpen={openWarningModal}
        closeModal={() => setOpenWarningModal(false)}
        onChange={handleDelete}
      />
    </>
  );
};

export default EditDropdownItem;

const Container = styled.div`
  position: absolute;
  z-index: 1000;
  left: 5%;

  display: inline-flex;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;

  border-radius: 8px;
  background: var(--alias-color-background-normal-normal);
  box-shadow: var(--alias-style-shadow-strong);
`;

const NameContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
`;

const BtnContainer = styled.div`
  display: flex;
  padding: 4px 8px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;
